import { useMutation } from 'react-query';
import { AxiosResponse } from 'axios';

// components
import { setItemToLocalStorage } from 'components/conversations';
import { errorToast } from 'components/toasts/error';
// configs
import { API } from 'configs/api';
// constants
import { LOCAL_STORAGE_CONVERSATION } from 'const/keys';
// context
import { useSockets } from 'context/socket/SocketProvider';
import { ISOCKET_ACTIONS } from 'context/socket/types';
// types
import { ISingleConversation, ICreateConversationParams } from './types';
// utils
import { getAllConversationsFromLocalStorage } from 'utils/conversations';
import { getShortUrlFromUrl } from 'utils/url';

export const createConversationsMutation = async ({
  data,
}: {
  data: ICreateConversationParams;
}) => {
  const shortUrl = getShortUrlFromUrl();
  const response: AxiosResponse<ISingleConversation> =
    await API.post<ISingleConversation>(
      `/playback/${shortUrl}/conversations`,
      data
    );

  return response.data;
};

export const useCreateConversations = () => {
  const { setCurrentConversation, socket } = useSockets();
  const shortUrl = getShortUrlFromUrl();
  return useMutation<
    ISingleConversation,
    Error,
    { data: ICreateConversationParams }
  >(createConversationsMutation, {
    onSuccess: (data: ISingleConversation) => {
      if (!shortUrl) {
        throw new Error('Invalid url');
      }
      setCurrentConversation({
        conversationId: `${data.conversationId}`,
        userId: data.userId,
      });

      const conversations = getAllConversationsFromLocalStorage();
      setItemToLocalStorage(LOCAL_STORAGE_CONVERSATION, {
        [shortUrl]: {
          conversationId: data.conversationId,
          userId: data.userId,
        },
        ...(!conversations ? {} : conversations),
      });

      socket?.emit(ISOCKET_ACTIONS.CONNECT_CONVERSATION, {
        conversationId: Number(data.conversationId),
        userId: data.userId,
      });
    },
    onError: () => {
      errorToast({ title: 'Something went wrong' });
    },
  });
};
